import config from '../config/app'
import axios from 'axios'
import Helper from '../helper/helper'
import store from '../store'

const PATH = '/family'
const VERSION = '/v2'

export default {
  getUserStoriesNew (userId, additionalFields, filters) {
    if (filters !== undefined) {
      filters.user_id = userId
    } else {
      filters = {user_id: userId}
    }
    if (additionalFields !== null && additionalFields !== undefined) {
      filters.additional = additionalFields.join(',')
    }
    let stringParams = Object.keys(filters).filter((i) => { return filters[i] !== '' && filters[i] !== null }).map((k) => {
      return filters[k] !== null && filters[k] !== undefined && typeof filters[k] === 'object' ? Object.keys(filters[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(filters[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(filters[k])
    }).join('&')
    let url = config.server + VERSION + PATH + '/storyNew' + '?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserStories (userId, additionalFields, filters) {
    if (filters !== undefined) {
      filters.user_id = userId
    } else {
      filters = {user_id: userId}
    }
    if (additionalFields !== null && additionalFields !== undefined) {
      filters.additional = additionalFields.join(',')
    }
    let stringParams = Object.keys(filters).filter((i) => { return filters[i] !== '' && filters[i] !== null }).map((k) => {
      return filters[k] !== null && filters[k] !== undefined && typeof filters[k] === 'object' ? Object.keys(filters[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(filters[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(filters[k])
    }).join('&')
    let url = config.server + VERSION + PATH + '?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getUserBusinessStoryTemplates (userId, additionalFields, filters) {
    if (filters !== undefined) {
      filters.user_id = userId
    } else {
      filters = {user_id: userId}
    }
    if (additionalFields !== null && additionalFields !== undefined) {
      filters.additional = additionalFields.join(',')
    }
    let stringParams = Object.keys(filters).filter((i) => { return filters[i] !== '' && filters[i] !== null }).map((k) => {
      return filters[k] !== null && filters[k] !== undefined && typeof filters[k] === 'object' ? Object.keys(filters[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(filters[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(filters[k])
    }).join('&')
    let url = config.server + VERSION + PATH + '/business/templates?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  addUserBusinessStoryTemplates (data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/business/templates'
      axios.request({
        method: 'post',
        url: url,
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  storeFamilyGivingStoryImage (data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/add-story-image'
      axios.request({
        method: 'post',
        url: url,
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteUserBusinessStoryTemplate (id) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/business/templates/' + id
      axios.delete(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  saveStory (data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH
      axios.post(url, data).then((response) => {
        resolve(response.data)
        if (store.getters.currentUser !== null) {
          if (store.getters.currentUser.register_source === 'trial-online') {
            window.gtag('event', 'TRIAL7 Created Recurring Impacts', {
              event_category: 'TRIAL7_Created_Recurring_Impacts',
              event_label: 'TRIAL7_Created_Recurring_Impacts',
              value: 'Yes'
            })
          }
        }
      }, (error) => {
        reject(error)
      })
    })
  },
  saveDestinationLink (data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/saveDestinationLink'
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  get (params, additional) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + VERSION + PATH + '?' + stringParams
    // let url = config.server + '/story' + '?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getStories (ids, additionalFields) {
    return this.get({ids: ids}, additionalFields)
  },
  getStoriesCSVData (data) {
    return new Promise((resolve, reject) => {
      let url = config.server + PATH + '/csv-data'
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  activateStory (id, data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/' + id + '/activate'
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  addStorytoCardPost (id) {
    return new Promise((resolve, reject) => {
      let url = config.server + '/cart/post/' + id
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  activateStoryNew (id, data) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/' + id + '/activate-new'
      axios.post(url, data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  moveToDraft (id) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/' + id + '/move-draft'
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getstoryMultiProject (id) {
    return new Promise((resolve, reject) => {
      let url = config.server + VERSION + PATH + '/' + id + '/get-multiproject-stories'
      axios.post(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  remove (id, pageTitle = '') {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + VERSION + PATH + '/' + id + '?page_title=' + pageTitle).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  sendEmbedStorySegment (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + VERSION + PATH + '/embed-story', data).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  /*
   Old API's
   Remove after evertything is done
   */
  getByIdPubic (id, additional) {
    let params = {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + PATH + '/' + id + '?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompnayDowngradeStatus (id, additional) {
    let url = config.server + PATH + '/getCompanyStatus/' + id
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getById (id, additionalFields) {
    console.log('Getting story by id:', id)
    return new Promise((resolve, reject) => {
      this.get({id: id}, additionalFields).then((response) => {
        console.log('Response for story id', id, ':', response)
        resolve(response[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  getByUserId (userId, additionalFields, filters) {
    if (filters !== undefined) {
      filters.user_id = userId
    } else {
      filters = {user_id: userId}
    }
    return this.get(filters, additionalFields)
  },
  search (key, additional) {
    return this.get({status: 1, search: key}, additional)
  },
  getCountStoriesByCompanyId (companyId) {
    return new Promise((resolve, reject) => {
      this.get({count: true, status: 1, company_id: companyId}).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCountStoriesByUserId (userId) {
    return new Promise((resolve, reject) => {
      this.get({count: true, status: 1, user_id: userId}).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  story (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: config.server + PATH,
        mimeType: 'multipart/form-data',
        data: Helper.getFormData(data)
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  shareInLinkedIn (story) {
    let data = {
      'comment': 'My Recurring Impacts on B1G1: Business for Good. See more at b1g1.com',
      'content': {
        'title': 'B1G1',
        'description': 'My Recurring Impacts on B1G1: Business for Good. See more at b1g1.com',
        'submitted-url': 'https://b1g1.com',
        'submitted-image-url': story.icon
      },
      'visibility': {
        'code': 'anyone'
      }
    }
    let configs = {
      headers: {
        'Access-Control-Allow-Origin': 'https://api.linkedin.com',
        'Content-type': 'application/json',
        'x-li-format': 'json'
      }
    }
    return new Promise((resolve, reject) => {
      axios.post('https://api.linkedin.com/v1/people/~/shares?format=json', data, configs).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getStory (userId, storyId, projectId, companyId = '') {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/story/checkIsInCart', {
        user_id: userId,
        project_id: projectId,
        story_id: storyId,
        company_id: companyId
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/story.js